import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=ededf2d8&scoped=true&lang=pug&"
import script from "./NewsItem.vue?vue&type=script&lang=js&"
export * from "./NewsItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsItem.scss?vue&type=style&index=0&id=ededf2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ededf2d8",
  null
  
)

export default component.exports